const getCurrencyFromCountry = () => {
    const pageURL = window.location.pathname;
    const countryUrl = pageURL.split('/')[1];
    const currency = {
        ae: 'AED',
        au: 'AUD',
        ca: 'CAD',
        ch: 'CHF',
        hk: 'HKD',
        jp: 'JPY',
        kr: 'KRW',
        mx: 'MXN',
        nz: 'NZD',
        sa: 'SAR',
        sg: 'SGD',
        th: 'THB',
        uk: 'GBP',
        us: 'USD'
    };
    return currency[countryUrl] || 'EUR';
};

const productInfoGA4 = item => {
    const priceClear = item.price || '';

    return {
        item_list_name: item.list,
        item_id: item.id,
        item_brand: 'unknown',
        item_name: item.name,
        currency: getCurrencyFromCountry(),
        index: item.position,
        item_category: item.category,
        item_variant: item.variant,
        price: priceClear,
        quantity: '1'
    };
};

function productListToViewItems(productList) {
    const result = [];

    for (let i = 0; i < productList.length; i++) {
        result.push(productInfoGA4(productList[i]));
    }

    return result;
}

export function trackViewItemList(trackProduct, pageNumber, dataLayer) {
    try {
        window.analyticsSdk.tracking.sendEvent({
            name: 'view_item_list',
            event: {
                event: 'view_item_list',
                country: window.location.pathname.split('/')[1],
                language: window.location.pathname.split('/')[2],
                item_list_id: window.location.pathname,
                item_list_name: trackProduct[0].list,
                items: productListToViewItems(trackProduct)
            }
        });
    } catch (e) {
        console.error('Problem with Analytics SDK: unable to track view_item_list');
    }
    const jsonData = {
        event: 'productImpressionPageN',
        page: `${pageNumber}`,
        ecommerce: { impressions: trackProduct }
    };
    dataLayer.push(jsonData);
}
